__turbopack_context__.v({
  "tab": "Tab-module-scss-module__bLIEaa__tab",
  "tab_button": "Tab-module-scss-module__bLIEaa__tab_button",
  "tab_dark": "Tab-module-scss-module__bLIEaa__tab_dark",
  "tab_fill": "Tab-module-scss-module__bLIEaa__tab_fill",
  "tab_light": "Tab-module-scss-module__bLIEaa__tab_light",
  "tab_list": "Tab-module-scss-module__bLIEaa__tab_list",
  "tab_list_button": "Tab-module-scss-module__bLIEaa__tab_list_button",
  "tab_list_dark": "Tab-module-scss-module__bLIEaa__tab_list_dark",
  "tab_list_underline": "Tab-module-scss-module__bLIEaa__tab_list_underline",
  "tab_mo_w112": "Tab-module-scss-module__bLIEaa__tab_mo_w112",
  "tab_mo_w170": "Tab-module-scss-module__bLIEaa__tab_mo_w170",
  "tab_mo_w_auto": "Tab-module-scss-module__bLIEaa__tab_mo_w_auto",
  "tab_mo_w_full": "Tab-module-scss-module__bLIEaa__tab_mo_w_full",
  "tab_outline": "Tab-module-scss-module__bLIEaa__tab_outline",
  "tab_underline": "Tab-module-scss-module__bLIEaa__tab_underline",
  "tab_w112": "Tab-module-scss-module__bLIEaa__tab_w112",
  "tab_w170": "Tab-module-scss-module__bLIEaa__tab_w170",
  "tab_w_auto": "Tab-module-scss-module__bLIEaa__tab_w_auto",
  "tab_w_full": "Tab-module-scss-module__bLIEaa__tab_w_full",
});
